class CartDrawer extends HTMLElement {
  constructor() {
    super();

   const openCartBtn = document.querySelector('.js-drawer-open-cart');
const addToCartBtn = document.querySelector('.add-to-cart');
[openCartBtn, addToCartBtn].forEach(item => {
  if (item) {
    item.addEventListener('click', () => {
      if (document.querySelector('#CartDrawer').classList.contains('is-empty')) {
        const checkCartNotEmpty = setInterval(() => {
          if (!document.querySelector('#CartDrawer').classList.contains('is-empty')) {
            this.render();
            clearInterval(checkCartNotEmpty);
          }
        }, 100);
      } else {
        setTimeout(() => {
          this.render();
        }, 500);
      }
    });
  }
});
  }

  addUpsell() {
    this.addButtons = document.querySelectorAll('.upsell-card__add-btn');
    this.addButtons.forEach(btn => {
      btn.addEventListener('click', async () => {
        await this.addToCart(btn).then(() => {
          this.render();
        });
      })
    });
  }

  updateQuantity() {
    this.quantityButtons = document.querySelectorAll('.js-qty__drawer');
    this.quantityButtons.forEach(btn => {
      btn.addEventListener('click', async () => {
        let currentQuantity = btn.parentElement.querySelector('input').value
        let currentId = btn.parentElement.querySelector('input').getAttribute('data-id');
        if (btn.classList.contains('js-qty__adjust--plus')) {
          await this.changeQuantity(currentId, ++currentQuantity)
        } else if (btn.classList.contains('js-qty__adjust--minus')) {
          await this.changeQuantity(currentId, --currentQuantity)
        }
        this.render();
      })
    })
  }

  async addToCart(btn) {
    const id = btn.getAttribute('data-id');
    const formData = {
      'items': [{
        'id': id,
        'quantity': 1
      }]
    };
    const res = await fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    });
    console.log(await res.json());
    return res;
  }

  async changeQuantity(key, quantity) {
    const data = {
      id: key,
      quantity: quantity,
    };
    const config = fetchConfig();
    config.body = JSON.stringify(data);

    const res = await fetch(
      window.Shopify.routes.root + 'cart/change.js',
      config
    );
    return res;

    function fetchConfig(type = 'json') {
      return {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
      };
    }
  }

  async render() {
    const newHTML = await this.fetchSection();
    const parser = new DOMParser();
    let resAsHtml = parser.parseFromString(newHTML, 'text/html');

    const updatedCart = resAsHtml.querySelector('#CartDrawer');
    const currentContent = document.querySelector('.drawer__inner');
    const newContent = updatedCart.querySelector('.drawer__inner');

    if (currentContent.innerHTML === newContent.innerHTML) {
      return;
    } else {
      currentContent.innerHTML = newContent.innerHTML;
    }

    const size = document.querySelector('.cart__items').getAttribute('data-count');
    if (size == 0) {
      document.querySelector('#CartDrawer').classList.add('is-empty');
      document.querySelector('.cart-link__bubble').classList.remove('cart-link__bubble--visible');
    } else {
      document.querySelector('#CartDrawer').classList.remove('is-empty');
      document.querySelector('.cart-link__bubble').classList.add('cart-link__bubble--visible');
    }

    this.registerSwitchButtons();
    this.addUpsell();
    this.updateQuantity()
  }

  async fetchSection() {
    const res = await fetch(
      window.Shopify.routes.root + '?section_id=header');
    const text = await res.text();
    return text;
  }

  registerSwitchButtons() {
    this.getNavButtons = document.querySelectorAll('[data-switch-action]');
    this.getAllCards = document.querySelectorAll('.upsell-card');

    if (this.getAllCards.length < 2) {
      this.getNavButtons[1].setAttribute("data-active", 'false');
    } else {
      this.getNavButtons[1].setAttribute("data-active", 'true');
    }

    if (this.getAllCards.length == 0) {
      document.querySelector('.upsell-products').style.display = 'none';
    } else {
      document.querySelector('.upsell-products').style.display = 'block';
    }

    this.getNavButtons.forEach(button => {
      button.addEventListener("click", () => {
        const upsellList = document.querySelector(".upsell-products__list");
        const currentCardWidth = document.querySelector(".upsell-card").getBoundingClientRect().width;
        const currentScrollLeft = upsellList.scrollLeft;
        const switchAction = button.dataset.switchAction;
        const otherSwitchButton = document.querySelector(`[data-switch-action='${switchAction === "prev" ? "next" : "prev"}']`);
        let upsellListWith = upsellList.scrollWidth - currentCardWidth - 100;
        let nextScrollLeft = switchAction === "prev" ? currentScrollLeft - currentCardWidth : currentScrollLeft + currentCardWidth;

        upsellList.scrollLeft = nextScrollLeft;

        if ((nextScrollLeft < 1 && switchAction === "prev") || (nextScrollLeft > upsellListWith && switchAction === "next")) {
          button.setAttribute("data-active", 'false');
        } else {
          button.setAttribute("data-active", "true");
        }
        otherSwitchButton.setAttribute("data-active", 'true');
      });

    });
  }

}

customElements.define('cart-drawer', CartDrawer);